import { useEffect, useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import c1 from "../assets/images/c1.jpg";
import c2 from "../assets/images/c2.jpg";
import c3 from "../assets/images/c3.jpg";
import "./Carousel.css";

function CarouselFade() {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}/landing`)
      .then((response) => {
        if (!response.ok) throw new Error('Failed to fetch');
        return response.json();
      })
      .then((data) => {
        setBanners(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error('Error fetching banners:', err);
        setError(true);
        setLoading(false);
      });
  }, []);

  const defaultSlides = [
    { photo: c1, alt: "Premium Collection - Discover Quality", title: "Premium Collection", subtitle: "Discover Quality Products" },
    { photo: c2, alt: "Special Offers - Save More", title: "Special Offers", subtitle: "Save More on Your Favorites" },
    { photo: c3, alt: "New Arrivals - Latest Trends", title: "New Arrivals", subtitle: "Latest Trends & Styles" }
  ];

  const handleSelect = (selectedIndex) => {
    setActiveIndex(selectedIndex);
  };

  const styles = {
    carouselContainer: {
      position: 'relative',
      borderRadius: '20px',
      overflow: 'hidden',
      boxShadow: '0 20px 60px rgba(0, 0, 0, 0.15)',
      margin: '20px 0',
      background: 'linear-gradient(145deg, #f8f9fa, #e9ecef)'
    },
    carouselInner: {
      borderRadius: '20px'
    },
    carouselItem: {
      position: 'relative',
      height: '500px',
      overflow: 'hidden'
    },
    carouselImage: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      transition: 'transform 0.8s ease-in-out',
      filter: 'brightness(0.85)'
    },
    carouselOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'linear-gradient(135deg, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0.1) 50%, rgba(0,0,0,0.3) 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column'
    },
    carouselCaption: {
      position: 'absolute',
      bottom: '60px',
      left: '50px',
      right: '50px',
      textAlign: 'left',
      color: 'white',
      zIndex: 2
    },
    captionTitle: {
      fontSize: '3rem',
      fontWeight: '700',
      marginBottom: '15px',
      textShadow: '2px 2px 4px rgba(0,0,0,0.8)',
      lineHeight: '1.2',
      animation: 'slideInUp 1s ease-out'
    },
    captionSubtitle: {
      fontSize: '1.3rem',
      fontWeight: '300',
      marginBottom: '25px',
      textShadow: '1px 1px 3px rgba(0,0,0,0.7)',
      opacity: '0.95',
      animation: 'slideInUp 1s ease-out 0.3s both'
    },
    shopButton: {
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      border: 'none',
      color: 'white',
      padding: '15px 35px',
      fontSize: '16px',
      fontWeight: '600',
      borderRadius: '50px',
      textDecoration: 'none',
      display: 'inline-block',
      transition: 'all 0.3s ease',
      textTransform: 'uppercase',
      letterSpacing: '1px',
      boxShadow: '0 8px 25px rgba(102, 126, 234, 0.4)',
      animation: 'slideInUp 1s ease-out 0.6s both'
    },
    customIndicators: {
      position: 'absolute',
      bottom: '20px',
      left: '50%',
      transform: 'translateX(-50%)',
      display: 'flex',
      gap: '12px',
      zIndex: 3
    },
    indicator: {
      width: '12px',
      height: '12px',
      borderRadius: '50%',
      backgroundColor: 'rgba(255, 255, 255, 0.5)',
      border: '2px solid white',
      cursor: 'pointer',
      transition: 'all 0.3s ease'
    },
    activeIndicator: {
      backgroundColor: 'white',
      transform: 'scale(1.2)'
    },
    customControls: {
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      backgroundColor: 'rgba(255, 255, 255, 0.15)',
      border: 'none',
      color: 'white',
      fontSize: '24px',
      padding: '15px 20px',
      borderRadius: '50%',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      backdropFilter: 'blur(10px)',
      zIndex: 3
    },
    prevControl: {
      left: '30px'
    },
    nextControl: {
      right: '30px'
    },
    loadingContainer: {
      height: '500px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
      borderRadius: '20px'
    },
    loadingSpinner: {
      width: '50px',
      height: '50px',
      border: '4px solid #f3f3f3',
      borderTop: '4px solid #667eea',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite'
    },
    errorContainer: {
      height: '500px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      background: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)',
      borderRadius: '20px',
      color: '#d32f2f'
    },
    imageCounter: {
      position: 'absolute',
      top: '20px',
      right: '20px',
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
      color: 'white',
      padding: '8px 15px',
      borderRadius: '20px',
      fontSize: '14px',
      fontWeight: '500',
      zIndex: 3,
      backdropFilter: 'blur(10px)'
    }
  };

  if (loading) {
    return (
      <div style={styles.carouselContainer}>
        <div style={styles.loadingContainer}>
          <div style={styles.loadingSpinner}></div>
        </div>
      </div>
    );
  }

  const slidesToShow = banners && banners.length ? banners : defaultSlides;

  return (
    <>
      <style>
        {`
        @keyframes slideInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        
        .custom-carousel .carousel-inner {
          border-radius: 20px;
        }
        
        .custom-carousel .carousel-item img:hover {
          transform: scale(1.05);
          filter: brightness(0.9);
        }
        
        .custom-carousel .carousel-control-prev,
        .custom-carousel .carousel-control-next {
          width: auto;
          opacity: 1;
        }
        
        .custom-carousel .carousel-control-prev:hover,
        .custom-carousel .carousel-control-next:hover {
          background-color: rgba(255, 255, 255, 0.25);
          transform: translateY(-50%) scale(1.1);
        }
        
        .custom-carousel .carousel-indicators {
          display: none;
        }
        
        .shop-btn:hover {
          transform: translateY(-3px);
          box-shadow: 0 12px 35px rgba(102, 126, 234, 0.6);
          background: linear-gradient(135deg, #764ba2 0%, #667eea 100%);
        }
        
        .custom-indicator:hover {
          background-color: rgba(255, 255, 255, 0.8);
          transform: scale(1.1);
        }
        
        @media (max-width: 768px) {
          .carousel-caption-custom {
            bottom: 30px !important;
            left: 20px !important;
            right: 20px !important;
          }
          
          .caption-title-custom {
            font-size: 2rem !important;
          }
          
          .caption-subtitle-custom {
            font-size: 1rem !important;
          }
          
          .custom-controls {
            padding: 10px 15px !important;
            font-size: 20px !important;
          }
          
          .prev-control {
            left: 15px !important;
          }
          
          .next-control {
            right: 15px !important;
          }
        }
        
        @media (max-width: 576px) {
          .carousel-item-custom {
            height: 350px !important;
          }
          
          .caption-title-custom {
            font-size: 1.5rem !important;
          }
          
          .shop-btn-custom {
            padding: 12px 25px !important;
            font-size: 14px !important;
          }
        }
        `}
      </style>

      <div className="carouselContainer"
      // style={styles.carouselContainer}
      >
        {error ? (
          <div style={styles.errorContainer}>
            <i className="fa fa-exclamation-triangle" style={{ fontSize: '48px', marginBottom: '20px' }}></i>
            <h4>Failed to load banners</h4>
            <p>Using default images instead</p>
          </div>
        ) : (
          <>
            <Carousel
              fade
              activeIndex={activeIndex}
              onSelect={handleSelect}
              className="custom-carousel"
              interval={5000}
              pause="hover"
            >
              {slidesToShow.map((item, index) => (
                <Carousel.Item key={index}
                  // style={styles.carouselItem} 
                  className="carouselItem">
                  <img
                    style={styles.carouselImage}
                    src={banners.length ? `${process.env.REACT_APP_BANNER_IMAGE_URL}/${item.photo}` : item.photo}
                    alt={item.alt || `Slide ${index + 1}`}
                    onError={(e) => {
                      e.target.src = 'https://via.placeholder.com/1200x500/667eea/ffffff?text=Image+Not+Available';
                    }}
                  />
                  <div style={styles.carouselOverlay}>
                    <div style={styles.carouselCaption} className="carousel-caption-custom">
                      {(item.title || defaultSlides[index]?.title) && (
                        <h2 style={styles.captionTitle} className="caption-title-custom">
                          {item.title || defaultSlides[index]?.title}
                        </h2>
                      )}
                      {(item.subtitle || defaultSlides[index]?.subtitle) && (
                        <p style={styles.captionSubtitle} className="caption-subtitle-custom">
                          {item.subtitle || defaultSlides[index]?.subtitle}
                        </p>
                      )}
                      <a
                        href="#shop"
                        style={styles.shopButton}
                        className="shop-btn shop-btn-custom"
                      >
                        <i className="fa fa-shopping-bag" style={{ marginRight: '8px' }}></i>
                        Shop Now
                      </a>
                    </div>
                  </div>
                </Carousel.Item>
              ))}
            </Carousel>

            {/* Custom Indicators */}
            <div style={styles.customIndicators}>
              {slidesToShow.map((_, index) => (
                <div
                  key={index}
                  style={{
                    ...styles.indicator,
                    ...(activeIndex === index ? styles.activeIndicator : {})
                  }}
                  className="custom-indicator"
                  onClick={() => setActiveIndex(index)}
                />
              ))}
            </div>

            {/* Image Counter */}
            <div style={styles.imageCounter}>
              {activeIndex + 1} / {slidesToShow.length}
            </div>

            {/* Custom Controls */}
            <button
              style={{ ...styles.customControls, ...styles.prevControl }}
              className="custom-controls prev-control"
              onClick={() => setActiveIndex(activeIndex === 0 ? slidesToShow.length - 1 : activeIndex - 1)}
            >
              <i className="fa fa-chevron-left"></i>
            </button>
            <button
              style={{ ...styles.customControls, ...styles.nextControl }}
              className="custom-controls next-control"
              onClick={() => setActiveIndex(activeIndex === slidesToShow.length - 1 ? 0 : activeIndex + 1)}
            >
              <i className="fa fa-chevron-right"></i>
            </button>
          </>
        )}
      </div>
    </>
  );
}

export default CarouselFade;